// import type { IExamAttemptsQuestionDto } from "./types";
import type { IPathBaseParam } from "./path";
import type { IInteractiveExamSubmissionsDto } from "./type";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import type { IInteractiveExamAttemptResponse } from "@api/courses/exams/interactive/attempts/types";

const postApis = createPostApi<
  IApiResponse<IInteractiveExamAttemptResponse>,
  IPathBaseParam,
  IInteractiveExamSubmissionsDto
>(
  "courses.exams.interactive.interactiveExamAttempt.interactiveExamSubmissions",
);

export const interactiveExamSubmissions = {
  ...postApis,
};
